<template>
    <div>
        <div v-if="showModal" class="modal-modern modal show" id="widgetConfigModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Widget Configuration</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="channel_id">Channel</label>
                            <select class="form-control" v-model="configuration.channelId" name="channel_id" id="channel_id">
                                <option :value="null">Global</option>
                                <option v-for="(channel, index) in channels" :value="channel.id" :key="index">{{channel.channel_name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="confirmConfig">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeDashboard.id != 0 && activeDashboard.widgets.length == 0" class="dashboard-not-found">
            <div v-if="activeDashboard.id === null" class="icon"><i class="fas fa-times-circle"></i></div>
            <div v-else class="icon"><i class="fas fa-exclamation-circle"></i></div>
            <div v-if="activeDashboard.id === null" class="copy">No Dashboards Found</div>
            <div v-else class="copy">No Widgets Configured</div>
        </div>
        <div v-else class="dashboard-widgets">
            <draggable @change="showConfigModal" class="dragArea row" :disabled="editDisabled" group="widgetData" v-model="activeDashboard.widgets">
                <div :class="widgetSize(widget.size)" v-for="(widget, index) in activeDashboard.widgets">
                    <plan-details :key="widget.widget_id" v-if="widget.template == 'plan-details'" :plan-details="widget.data"></plan-details>
                    <user-activity :key="widget.widget_id" v-if="widget.template == 'user-activity'" :edit-disabled="editDisabled" :widget-data="widget"></user-activity>
                    <product-activity :key="widget.widget_id" v-if="widget.template == 'product-activity'" :edit-disabled="editDisabled" :widget-data="widget"></product-activity>
                    <widget-list :key="widget.widget_id" v-if="widget.template == 'list'" :edit-disabled="editDisabled" :widget-data="widget"></widget-list>
                    <big-value-widget :key="widget.widget_id" v-if="widget.template == 'big-value'" :edit-disabled="editDisabled" :widget-data="widget"></big-value-widget>
                    <widget-chart :key="widget.widget_id" v-if="widget.template == 'chart'" :edit-disabled="editDisabled" :chartId="'chart_'+ widget.widget_id" :chart-data="widget"></widget-chart>
                    <widget-triple-chart :key="widget.widget_id" v-if="widget.template == 'triple-chart'" :edit-disabled="editDisabled" :chartId="'chart_'+ index" :chart-data="widget"></widget-triple-chart>
                    <widget-json :key="widget.widget_id" v-if="widget.template !== 'plan-details' && widget.template !== 'user-activity' && widget.template !== 'product-activity' && widget.template !== 'big-value' && widget.template !== 'chart' && widget.template !== 'list' && widget.template !== 'triple-chart' && widget.template !== 'weather'" :edit-disabled="editDisabled" :widget-data="widget"></widget-json>
                </div>
            </draggable>
            <div class="no-widgets-message" v-if="activeDashboard.widgets.length === 0">
                <div><i class="fa fa-plus"></i></div>
                <div class="copy">Add your first widget</div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host



    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';
    import draggable from 'vuedraggable'
    import Chart from 'chart.js';

    import PlanDetails from './widgets/plan-details.vue';
    import BigValueWidget from './widgets/big-value-widget.vue';
    import WidgetChart from './widgets/widget-chart.vue';
    import WidgetJson from './widgets/widget-json.vue';
    import UserActivity from './widgets/user-activity.vue';
    import ProductActivity from './widgets/product-activity.vue';
    import WidgetList from './widgets/widget-list.vue';
    import WidgetTripleChart from './widgets/widget-triple-chart.vue';


    Vue.use(VueEvents)

    export default {
        name: 'dashboard-widgets',
        props: [
            'editDisabled',
            'createMode',
            'activeDashboard',
        ],
        components:{
            PlanDetails,
            BigValueWidget,
            WidgetList,
            WidgetChart,
            UserActivity,
            WidgetTripleChart,
            // WidgetWeather,
            ProductActivity,
            WidgetJson,
            draggable
        },
        data() {
            return {
                widgetData: this.activeDashboard.widgets,
                showModal: true,
                selectedWidget: {},
                configuration: {
                    channelId: null,
                    showError: false
                },
                channels: null
            }
        },
        mounted() {
            this.getChannels();
        },
        methods: {
            confirmConfig: function() {
                if(this.configuration.channelId != null) {
                    this.selectedWidget.configuration = {channelId: this.configuration.channelId};
                } else {
                    this.selectedWidget.configuration = null;
                }
                this.$emit('widgetConfigured', this.selectedWidget);
                this.configuration.channelId = null;
                $('#widgetConfigModal').modal('hide');
            },
            showConfigModal: function(newIndex, element) {
                if (! newIndex.added.element.isChannelable) {
                    return;
                }
                $('#widgetConfigModal').modal('show');
                this.selectedWidget = newIndex.added.element;
            },
            LoadWidgets: function(dashboardID){
                console.log('Loading Widgets');
            },
            removeWidget: function(dashboardID){
                console.log('Removing Widgets with ID=' + dashboardID);
            },
            getChannels: function() {
                axios.get(base_url + '/pimapi/channels')
                .then((response) => {
                    this.channels = response.data.data;
                });
            },
            widgetSize: function (size) {
                if (size == 's') {
                    return 'col-md-4';
                }
                if (size == 'm') {
                    return 'col-md-8';
                }
                if (size == 'l') {
                    return 'col-md-12';
                }
            }
        },
    };
</script>

<style lang="scss">
    .dashboard-widgets{
        position: relative;
        .widget-item{
            overflow:hidden;
            position: relative;
            margin-bottom:30px;
            padding:0 20px;
            background: rgba(255, 255, 255, 0.75);
            border: 1px solid #DEE0E1;
            border-radius: 12px;
            min-height:250px;
            max-height:250px;
            box-shadow: 0 0 3px 1px rgba(0,0,0,0.10);
            .widget-heading{
                position: relative;
                z-index:2;
                border-bottom:1px solid #F1F2F2;
                padding-top:15px;
                padding-bottom:15px;
                position: relative;
                .title{
                    float: left;
                    font-size: 18px;
                    color: #848484;
                    text-align: left;
                }
            }
            .remove-widget{
                position: absolute;
                top: 4px;
                right:11px;
                font-size: 20px;
                color: #AB5755;
            }
            .pim-informational{
                .plan-details{
                    border-right: 1px solid #F1F2F2;
                }
            }
        }
    }
    .dashboard-not-found{
        font-size: 16px;
        text-align: center;
        padding-top: 200px;
        color: #dcdee2;
        .icon{
            font-size: 40px;
            color: #1c4c6f;
        }
        .copy{
            color: #1c4c6f;
        }
    }
    .no-widgets-message{
        height:250px;
        padding: 80px;
        position: absolute;
        z-index: 1;
        top: 0px;
        left: 0px;
        right: 0px;
        color: #bbbbbb;
        border:1px dashed #d8dadc;
        text-align: center;
        font-size: 20px;
        .copy{
            margin-top: 10px;
        }
        .fa{
            font-size: 50px;
        }
    }
    .dragArea{
        min-height:250px;
    }
</style>
